import { ref } from 'vue';
import { EntityType } from '@/entities/entityType';

export const useEntityTypeRecord = () => ref<EntityType>({
  title: '',
  description: '',
  properties: [],
});
